/**
 * AI CONTEXT
 * Purpose: small status tag renderer for evaluation status values.
 * Depends on: status->color and label formatting helpers.
 * Used by: evaluation table rows/cards/modals.
 * Refactor: centralize fixed width/size style via design token or shared style prop.
 */
import { Tag } from "antd"

import { EVALUATION_STATUS } from "#customTypes/composedTypes/evaluationTypes"
import { getEvaluationStatusColor } from "#utils/evaluationHelpers"
import { camelToWords } from "#utils/textFormatters"

const EvaluationStatusTag = ({
  status = EVALUATION_STATUS.NOT_STARTED,
}: {
  status: string
}) => {
  const label = camelToWords(status)
  return (
    <Tag
      color={getEvaluationStatusColor(status)}
      style={{ height: "fit-content", width: 80, textAlign: "center" }}
    >
      {label}
    </Tag>
  )
}

export default EvaluationStatusTag
